// extracted by mini-css-extract-plugin
export default {"personalagreement":"PersonalAgreement_personalagreement__p9kd6","asterix":"PersonalAgreement_asterix__PeRXQ"};